import type { AxiosInstance } from 'axios';

import { throwApiError } from 'src/api/utils';

import type { TRawPadPreparationWithRSE, TSerializedPadPreparationWithRSE } from './types';

export class WellPadPreparationApi {
  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  async fetchPadPreparation(planVersionId: number, signal?: AbortSignal): Promise<TRawPadPreparationWithRSE[]> {
    try {
      const { data } = await this.agent.get('/pad-preparation/list', {
        params: {
          planVersionId,
        },
        signal,
      });

      return data;
    } catch (e) {
      throwApiError(e);
    }
  }

  async applyPadChanges(pad: TSerializedPadPreparationWithRSE, planVersionId: number): Promise<void> {
    try {
      await this.agent.patch(`/pad-preparation/${planVersionId}`, pad);
    } catch (e) {
      throwApiError(e);
    }
  }
}
